export default __webpack_public_path__ + "static/media/img.2c551db9.svg";